import React from "react";
import './KineticProcess.css';
import iconStep1  from '../../assets/img/imagine.svg';
import iconStep2  from '../../assets/img/strategize.svg';
import iconStep3  from '../../assets/img/create.svg';
import iconStep4  from '../../assets/img/activate.svg';
import Xarrow, {Xwrapper} from "react-xarrows";
import { AnimationOnScroll } from 'react-animation-on-scroll';

export default class KineticProcess extends React.Component {

	constructor(props){
		super(props)
		this.state = {
		}
	}

	generateArrowAnchorPoints(arrowNumber, extraStyles){
		return <div className="arrow-anchor-container" style={extraStyles||{}}>
			{Array.from(Array(10).keys()).map(index=>{
				let id="anchor-arrow-"+arrowNumber+"_"+index
				return <div id={id} key={id} style={{width:'10%'}}></div>
			})}
		</div>
	}
	render() {

		return (
		<div id="kinetic-process" className="process-container overflow-left-margin overflow-right-margin">
			<AnimationOnScroll initiallyVisible={false} animateIn="fadeDown" animateOnce={true} delay={0}>
				<div><h1 id="process-title" className="section-title"><span id="anchor-arrow-1a">THE</span> KINETIC CHAIN PROCESS</h1></div>
			</AnimationOnScroll>
			<AnimationOnScroll initiallyVisible={false} animateIn="fadeUp" animateOnce={true} delay={0}>
				<div className="process-briefing">
					<p className="item-body">A kinetic chain is a concept used to describe human movement. Starting from a strong base, kinetic energy amplifies as it moves from one body part to the next. Correct technique leverages the full system to perform powerful motions such as a tennis serve or a right hook.</p>
					<p className="item-body">We use this same principle in our work, starting from strong technical fundamentals and a firm understanding of the challenges at hand. Those lead to accurate insights, which we use to inform what and how we create the most effective and efficient product.</p>
					{this.generateArrowAnchorPoints(1, {marginBottom:'100px'})}
				</div>
			</AnimationOnScroll>

			<div className="process-step-row two-step-row">
				<div id="entryStep1a" className="process-step">

					<div id="entryStep1b" className="step-icon-wrapper">
						<img src={iconStep1} alt=""/>
					</div>
					<div className="step-description">
						<p className="item-title">IMAGINE</p>
						<p className="item-body">Curious about the WEB3 space, NFTs and blockchain? We'll provide an immersive session, or sessions, focused on educating your team on the NFT, crypto, and metaverse landscape, brainstorming how it could come to life for you.</p>
					</div>
					<div style={{display:'flex',width:'10%', flexDirection:'column'}}>
						<div id="exitStep1a" style={{height:'20%', width:'100%'}}></div>
						<div style={{height:'20%', width:'100%'}}></div>
						<div style={{height:'20%', width:'100%'}}></div>
						<div style={{height:'20%', width:'100%'}}></div>
						<div style={{height:'20%', width:'100%'}}></div>
					</div>
				</div>

				<div id="entryStep2a" className="process-step step-right">
					<div className="step-icon-wrapper">
						<img src={iconStep2} alt=""/>
					</div>
					<div className="step-description">
						<p className="item-title">STRATEGIZE</p>
						<p className="item-body">Let's formulate your high-level creative concept, where you can create true value, utility, and stand out from the smoke:</p>
						<p className="item-body">
							<ul>
								<li>Holistic creative wrapper</li>
								<li>Technical partners</li>
								<li>Audience-driven / utility-focused ideation</li>
								<li>KPIs to measure success</li>
							</ul>
						</p>
					</div>
				</div>
			</div>

			<div className="process-step-row one-step-row">
				<div id="entryStep1c" className="process-step">
					<div style={{display:'flex',width:'10%', flexDirection:'column'}}>
						<div id="entryStep1e" style={{height:'20%', width:'100%'}}></div>
						<div style={{height:'20%', width:'100%'}}></div>
						<div style={{height:'20%', width:'100%'}}></div>
						<div style={{height:'20%', width:'100%'}}></div>
						<div style={{height:'20%', width:'100%'}}></div>
					</div>

					<div id="entryStep1d" className="step-icon-wrapper">
						<img src={iconStep1} alt=""/>
					</div>
					<div className="step-description">
						<p className="item-title">IMAGINE</p>
						<p className="item-body">Curious about the WEB3 space, NFTs and blockchain? We'll provide an immersive session, or sessions, focused on educating your team on the NFT, crypto, and metaverse landscape, brainstorming how it could come to life for you.</p>
					</div>
					<div style={{display:'flex',width:'10%', flexDirection:'column'}}>
						<div id="exitStep1b" style={{height:'20%', width:'100%'}}></div>
						<div style={{height:'20%', width:'100%'}}></div>
						<div style={{height:'20%', width:'100%'}}></div>
						<div style={{height:'20%', width:'100%'}}></div>
						<div style={{height:'20%', width:'100%'}}></div>
					</div>
				</div>
			</div>

			<div className="process-step-row one-step-row">
				<div id="entryStep2b" className="process-step step-right">
					<div id="entryStep2c" className="step-icon-wrapper">
						<img src={iconStep2} alt=""/>
					</div>
					<div className="step-description">
						<p className="item-title">STRATEGIZE</p>
						<p className="item-body">Let's formulate your high-level creative concept, where you can create true value, utility, and stand out from the smoke:</p>
						<p className="item-body">
							<ul>
								<li>Holistic creative wrapper</li>
								<li>Technical partners</li>
								<li>Audience-driven / utility-focused ideation</li>
								<li>KPIs to measure success</li>
							</ul>
						</p>
					</div>
				</div>
			</div>

			<div className="process-step-row right-step-row two-step-row">
				<div id="entryStep3a" className="process-step">
					<div className="step-icon-wrapper">
						<img src={iconStep3} alt=""/>
					</div>
					<div className="step-description">
						<p className="item-title">CREATE</p>
						<p className="item-body">We marry in-depth expertise with strategic thinking to determine the best way to bring your NFT to market, including:</p>
						<p className="item-body">
							<ul>
								<li>Asset development and creation</li>
								<li>Launch strategy</li>
								<li>Web3 architecture and development</li>
								<li>Pricing, sale and support</li>
							</ul>
						</p>
					</div>
				</div>

				<div className="process-step step-right">
					<div style={{display:'flex',width:'0%', flexDirection:'column'}}>
						<div style={{height:'20%', width:'100%'}}></div>
						<div style={{height:'20%', width:'100%'}}></div>
						<div style={{height:'20%', width:'100%'}}></div>
						<div style={{height:'20%', width:'100%'}}></div>
						<div id="exitStep4a" style={{height:'20%', width:'100%'}}></div>
					</div>
					<div className="step-icon-wrapper">
						<img src={iconStep4} alt=""/>
					</div>
					<div className="step-description">
						<p className="item-title">ACTIVATE</p>
						<p className="item-body">Build it and they will come? Not so fast. NFT and WEB3 projects need attention and community-building to get your audience hyped and excited for your brand's future:</p>
						<p className="item-body">
							<ul>
								<li>Community management</li>
								<li>Leverage your existing partnerships and our network's industry connections in sports, art and entertainment.</li>
							</ul>
						</p>
					</div>
				</div>

			</div>

			<div className="process-step-row one-step-row" style={{flexDirection: "column"}}>
				{this.generateArrowAnchorPoints(3)}
				<div id="entryStep3b" className="process-step" style={{alignSelf: "center"}}>
					<div className="step-icon-wrapper">
						<img src={iconStep3} alt=""/>
					</div>
					<div className="step-description">
						<p className="item-title">CREATE</p>
						<p className="item-body">We marry in-depth expertise with strategic thinking to determine the best way to bring your NFT to market, including:</p>
						<p className="item-body">
							<ul>
								<li>Asset development and creation</li>
								<li>Launch strategy</li>
								<li>Web3 architecture and development</li>
								<li>Pricing, sale and support</li>
							</ul>
						</p>
					</div>
				</div>
				{this.generateArrowAnchorPoints(4, {marginTop:'-50px'})}
			</div>
			<div className="process-step-row one-step-row" style={{marginTop:'50px'}}>
				<div className="process-step step-right">
					<div style={{display:'flex',width:'10%', flexDirection:'column'}}>
						<div style={{height:'20%', width:'100%'}}></div>
						<div style={{height:'20%', width:'100%'}}></div>
						<div style={{height:'20%', width:'100%'}}></div>
						<div style={{height:'20%', width:'100%'}}></div>
						<div id="exitStep4b" style={{height:'20%', width:'100%'}}></div>
					</div>
					<div id="entryStep4a" className="step-icon-wrapper">
						<img src={iconStep4} alt=""/>
					</div>
					<div className="step-description">
						<p className="item-title">ACTIVATE</p>
						<p className="item-body">Build it and they will come? Not so fast. NFT and WEB3 projects need attention and community-building to get your audience hyped and excited for your brand's future:</p>
						<p className="item-body">
							<ul>
								<li>Community management</li>
								<li>Leverage your existing partnerships and our network's industry connections in sports, art and entertainment.</li>
							</ul>
						</p>
					</div>
				</div>
			</div>


			<div className="arrow1a two-step-row">
				<Xwrapper><Xarrow start="anchor-arrow-1a" end="entryStep1a" startAnchor="bottom" endAnchor="left" path="grid" lineColor="#ff7f00" headColor="#ff7f00" strokeWidth={1} headSize={10} dashness={{ strokeLen: 8, nonStrokeLen: 5, animation:2}}/></Xwrapper>
			</div>
			<div className="arrow1b two-step-row">
				<Xwrapper><Xarrow start="anchor-arrow-1a" end="entryStep1b" startAnchor="bottom" endAnchor="top" path="grid" lineColor="#ff7f00" headColor="#ff7f00" strokeWidth={1} headSize={10} dashness={{ strokeLen: 8, nonStrokeLen: 5, animation:2}}/></Xwrapper>
			</div>
			<div className="arrow1c one-step-row">
				<Xwrapper><Xarrow start="anchor-arrow-1_2" end="entryStep1d" startAnchor="bottom" endAnchor="top" path="grid" lineColor="#ff7f00" headColor="#ff7f00" strokeWidth={1} headSize={10} dashness={{ strokeLen: 8, nonStrokeLen: 5, animation:2}}/></Xwrapper>
			</div>
			<div className="arrow2a two-step-row">
				<Xwrapper><Xarrow start="exitStep1a" end="entryStep2a" startAnchor="right" endAnchor="top" path="grid" lineColor="#ff7f00" headColor="#ff7f00" strokeWidth={1} headSize={10} dashness={{ strokeLen: 8, nonStrokeLen: 5, animation:2}}/></Xwrapper>
			</div>
			<div className="arrow2b one-step-row">
				<Xwrapper><Xarrow start="entryStep1c" end="entryStep2c" startAnchor="bottom" endAnchor="top" path="grid" lineColor="#ff7f00" headColor="#ff7f00" strokeWidth={1} headSize={10} dashness={{ strokeLen: 8, nonStrokeLen: 5, animation:2}}/></Xwrapper>
			</div>
			<div className="arrow3a two-step-row">
				<Xwrapper><Xarrow start="entryStep2a" end="entryStep3a" startAnchor="bottom" endAnchor="top" path="grid" lineColor="#ff7f00" headColor="#ff7f00" strokeWidth={1} headSize={10} dashness={{ strokeLen: 8, nonStrokeLen: 5, animation:2}}/></Xwrapper>
			</div>
			<div className="arrow3b one-step-row">
				<Xwrapper><Xarrow start="entryStep2c" end="anchor-arrow-3_8" startAnchor="bottom" endAnchor="top" path="grid" lineColor="#ff7f00" headColor="#ff7f00" strokeWidth={1} headSize={10} dashness={{ strokeLen: 8, nonStrokeLen: 5, animation:2}}/></Xwrapper>
			</div>
			<div className="arrow4a two-step-row">
				<Xwrapper><Xarrow start="entryStep3a" end="exitStep4a" startAnchor="bottom" endAnchor="left" path="grid" lineColor="#ff7f00" headColor="#ff7f00" strokeWidth={1} headSize={10} dashness={{ strokeLen: 8, nonStrokeLen: 5, animation:2}}/></Xwrapper>
			</div>
			<div className="arrow4b one-step-row">
				<Xwrapper><Xarrow start="anchor-arrow-4_8" end="entryStep4a" startAnchor="bottom" endAnchor="top" path="grid" lineColor="#ff7f00" headColor="#ff7f00" strokeWidth={1} headSize={10} dashness={{ strokeLen: 8, nonStrokeLen: 5, animation:2}}/></Xwrapper>
			</div>
		</div>
		);
	}
}
